import { configureStore } from '@reduxjs/toolkit';
import teamsAuthReducer from './slices/teamsAuthSlice';

const store = configureStore({
  reducer: {
    teamsAuth: teamsAuthReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export default store;
